import { requester } from "App";
import Container from "layouts/container/Container";
import FlexChild from "layouts/flex/FlexChild";
import VerticalFlex from "layouts/flex/VerticalFlex";
import { useEffect, useRef, useState } from "react";
import style from "./VendingManagement.module.css";
import P from "components/P";
import { useNavigate } from "react-router-dom";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import InputText from "components/inputs/signUp/InputText";
import CustomButton from "components/buttons/CustomButton";
import Center from "layouts/wrapper/Center";

function VendingManagement() {
    const [isMounted, setMounted] = useState(false);
    const [vendingList, setVendingList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchResults, setSearchResults] = useState();
    const [vendingsPerPage] = useState(5);
    const searchRef = useRef();
    const navigate = useNavigate();

    useEffect(() => {
        setMounted(true);
    }, []);

    useEffect(() => {
        if (isMounted) {
            requester.findAllVending((result) => {
                setVendingList(result.data);
            });
        }
    }, [isMounted]);

    const indexOfLastVending = currentPage * vendingsPerPage;
    const indexOfFirstVending = indexOfLastVending - vendingsPerPage;
    const currentVendings = vendingList && vendingList.slice(indexOfFirstVending, indexOfLastVending);

    const totalPages = vendingList && Math.ceil(vendingList.length / vendingsPerPage);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const handleDetailClick = (vending) => {
        navigate("/admin/vending/list/detail", { state: { data: vending } });
    };

    const renderTableHeader = () => {
        if (currentVendings && currentVendings.length > 0) {
            const headers = Object.keys(currentVendings[0]);
            return headers.map((key, index) => (
                <th className={style.th} key={index}>{key}</th>
            )).concat(<th className={style.th}>Actions</th>);
        }
    };

    function getElapsedTime(heartbeat) {
        var now = new Date();
        var elapsedMilliseconds = now - heartbeat;

        var millisecondsInMinute = 1000 * 60;
        var elapsedMinutes = Math.floor(elapsedMilliseconds / millisecondsInMinute);

        if (elapsedMinutes === 0) {
            return "방금 전";
        } else if (elapsedMinutes === 1) {
            return "1분 전";
        } else {
            return elapsedMinutes + "분 전";
        }
    }

    const renderTableBody = () => {
        return currentVendings && currentVendings.map((vending, index) => (
            <tr className={`${index % 2 === 0 ? style.trEven : ''} ${style.trHover}`} key={index}>
                {Object.values(vending).map((value, cellIndex) => {
                    if (cellIndex == 7) {
                        var heartbeat = new Date(value); // 예시 데이터
                        var elapsedTime = getElapsedTime(heartbeat);
                        return <td className={style.td} key={cellIndex}>{elapsedTime}</td>
                    } else if (cellIndex == 8) {
                        return <img src={`data:image/png;base64,${value}`} style={{ height: "300px" }} />
                    } else {
                        return <td className={style.td} key={cellIndex}>{value}</td>
                    }
                }

                )}
                <td className={style.td}>
                    <button onClick={() => handleDetailClick(vending)} className={style.detailButton}>상세보기</button>
                </td>
            </tr>
        ));
    };
    const btnStyle = {
        backgroundColor: "var(--main-color)",
        border: "none"
    }
    const search = () => {
        
        let data = { userName: searchRef.current.getValue() }
        requester.searchVending(data, (result) => {
            
            setVendingList(result.data);
        })
    }

    return (
        <Container>
            <Container maxWidth={1200}>
                <VerticalFlex gap={20}>
                    <FlexChild>
                        <Center width={"100%"} textAlign={"left"}>
                            <P size={40} font={"gmarketSansBold"}>자판기 리스트</P>
                        </Center>
                    </FlexChild>
                    {/* <FlexChild>
                        <HorizontalFlex gap={30}>
                            <FlexChild width={"10%"} >
                                <Center>
                                    <P>점주 아이디 검색 : </P>
                                </Center>
                            </FlexChild>
                            <FlexChild>
                                <HorizontalFlex>
                                    <FlexChild >
                                        <InputText ref={searchRef} placeHolder={"점주 ID 검색"} />
                                    </FlexChild>
                                    <FlexChild>
                                        <CustomButton text={"검색"} style={btnStyle} onClick={search} />
                                    </FlexChild>
                                </HorizontalFlex>
                            </FlexChild>
                        </HorizontalFlex>
                    </FlexChild> */}
                    <FlexChild>
                        <table className={style.table}>
                            <thead>
                                <tr>{renderTableHeader()}</tr>
                            </thead>
                            <tbody>{renderTableBody()}</tbody>
                        </table>
                    </FlexChild>
                    <FlexChild >
                        <div className={style.paginationContainer}>
                            <div className={style.paginationArea}>
                                {Array.from({ length: totalPages }, (_, index) => (
                                    <button
                                        key={index + 1}
                                        onClick={() => paginate(index + 1)}
                                        className={`${style.pageButton} ${currentPage === index + 1 ? style.active : ''}`}
                                    >
                                        {index + 1}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </FlexChild>
                </VerticalFlex>
            </Container>
        </Container>
    );
}

export default VendingManagement;